document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtn = document.getElementById('load-more');
  if (!loadMoreBtn) return;

  loadMoreBtn.addEventListener('click', function () {
    const nextUrl = loadMoreBtn.dataset.next;

    loadMoreBtn.textContent = "Loading...";

    fetch(nextUrl)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data, "text/html");

        // Extract products
        const newProducts = htmlDoc.querySelectorAll('#product-grid > *');

        // Append them
        const productGrid = document.querySelector('#product-grid');
        newProducts.forEach(item => productGrid.appendChild(item));

        // Update next page
        const newNext = htmlDoc.querySelector('#load-more');
        if (newNext) {
          loadMoreBtn.dataset.next = newNext.dataset.next;
          loadMoreBtn.textContent = "Load more";
        } else {
          loadMoreBtn.remove();
        }
      });
  });
});
